var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.4167V3.16675C0.5 2.50371 0.763392 1.86782 1.23223 1.39898C1.70107 0.93014 2.33696 0.666748 3 0.666748H14.6667C14.8877 0.666748 15.0996 0.754545 15.2559 0.910826C15.4122 1.06711 15.5 1.27907 15.5 1.50008V16.5001C15.5 16.7211 15.4122 16.9331 15.2559 17.0893C15.0996 17.2456 14.8877 17.3334 14.6667 17.3334H3.41667C2.64312 17.3334 1.90125 17.0261 1.35427 16.4791C0.807291 15.9322 0.5 15.1903 0.5 14.4167ZM13.8333 15.6667V13.1667H3.41667C3.08515 13.1667 2.7672 13.2984 2.53278 13.5329C2.29836 13.7673 2.16667 14.0852 2.16667 14.4167C2.16667 14.7483 2.29836 15.0662 2.53278 15.3006C2.7672 15.5351 3.08515 15.6667 3.41667 15.6667H13.8333ZM2.16667 11.7809C2.55724 11.5954 2.98429 11.4995 3.41667 11.5001H13.8333V2.33341H3C2.77899 2.33341 2.56702 2.42121 2.41074 2.57749C2.25446 2.73377 2.16667 2.94573 2.16667 3.16675V11.7809Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.6ff5c0e9d4c0b5b9582d2ded223dd00e.svg";
export { ForwardRef as ReactComponent };